var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.787109L0 6.78711V15.7871C0 24.1121 5.76 31.8971 13.5 33.7871C21.24 31.8971 27 24.1121 27 15.7871V6.78711L13.5 0.787109ZM18.12 23.2871L13.5 20.5121L8.895 23.2871L10.11 18.0371L6.045 14.5271L11.415 14.0621L13.5 9.11211L15.585 14.0471L20.955 14.5121L16.89 18.0371L18.12 23.2871Z",
    fill: "#EF4626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.5e5a359ae1deb8e8a7b3677b88344bf7.svg";
export { ForwardRef as ReactComponent };